import { base, baseODATA } from '../base';

export const getQueryODATA = `${baseODATA}/fileexportsearchquery`;
export const fileExport = `${base}/FileExport`;
